import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const submitFeedbackForm = (data) => {
  return apiClient(ENDPOINTS.CUSTOMER_FEEDBACK_SUBMIT, {
    method: "POST",
    body: data,
  });
};
export const getcustomerfeedback = () => {
  return apiClient(ENDPOINTS.CUSTOMER_FEEDBACK_ALL, {
    method: "GET",
  });
};